<template>
  <div class="Drop-Menu Drop-Menu--small">
    <div class="Drop-Menu__item" v-if="get_isShowApprove">
      <ApproveSignal :signal="get_signal" />
    </div>
    <div class="Drop-Menu__item">
      <EditSignal :signal="get_signal" />
    </div>
    <div class="Drop-Menu__item" v-if="get_isShowAdminLink">
      <AdminLink :signal="get_signal" />
    </div>
    <div class="Drop-Menu__item" v-if="get_isShowAdminLink">
      <PinSignal :signal="get_signal" />
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { Props } from './scripts/props.js';
  import { useStore } from 'vuex';
  //--------------------------------------
  import ApproveSignal from './items/Approve/ApproveSignal.vue';
  import AdminLink from './items/AdminLink/AdminLink.vue';
  import PinSignal from './items/Pin/PinSignal';
  import EditSignal from './items/Edit/EditSignal.vue';
  //--------------------------------------
  const props = defineProps(Props());
  const store = useStore();
  //--------------------------------------
  //Является ли пользователь модератором?
  const get_isModerator = computed(() => store.getters['UserSystem/hasModeratorPrivileges']);
  //Получить пост для добавления в избраннное
  const get_signal = computed(() => store.state.OldSignals.data[props.signalId]);
  //Отображать ли кнопку 'Опубликовать'
  const get_isShowApprove = computed(() => !get_signal.value.live && get_isModerator.value);
  //Отображать ли кнопку 'Админка'
  const get_isShowAdminLink = computed(() => get_isModerator.value);
</script>

<style lang="scss">
  @import "../../styles/Drop-Menu";
</style>
